
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="flex items-center justify-between px-6 py-4 bg-white">
      <div className="flex items-center space-x-2">
        <div className="w-14 h-14 rounded-lg flex items-center justify-center">
          <img
            src="https://ik.imagekit.io/anvgrd1ahnys/DALM/Dalm%20Logos%20IMGKIT/favicon-dalm-test/apple-touch-icon_Hg0-6reJdv.png?updatedAt=1750176559662"
            alt="logo"
          />
        </div>
        <span className="text-xl font-bold text-gray-900">ConvoHub</span>
      </div>
      <nav className="flex items-center space-x-8">
        <a
          href="https://dalmlabs.com/contact"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-600 hover:text-gray-900 hidden md:block"
        >
          Contact
        </a>
        <Link
          to={'login'}
          className="text-blue-600 font-medium"
        >
          Sign In
        </Link>
        <Link
          to={'/create-account'}
          className="bg-blue-600 text-white px-4 py-2 hidden md:block rounded-lg hover:bg-blue-700 transition-colors"
        >
          Get Started
        </Link>
      </nav>
    </header>
  );
};

export default Header;
